import React, { useEffect, useMemo, useState } from "react";
import {
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  MenuItem,
  Select,
  TableCell,
  TableRow,
  TextField,
} from "@material-ui/core";
import { getTranslation } from "../../../heplers/translationHelper";
import { tenantCategories } from "../../enums";
import { DeleteIConButton } from "../../../components/ButttonsWithIcons";
import { format } from "../../../heplers/format";
import LocaleNumberField from "../../../components/LocaleNumberField";
import { parseLocaleNumber } from "../../../heplers/localeFormat";
import { common } from "@material-ui/core/colors";

const SplitAmount = ({ onSubmit, count, item, deleteItem, disabled }) => {

  // ---------- Local state (no Formik) ----------
  // const [values, setValues] = useState(() => ({
  //   isIndexed: !!item?.isIndexed,
  //   amount: item?.amount ?? "",
  //   type: item?.type ?? 0,
  //   description: item?.description ?? "",
  // }));

  const [errors, setErrors] = useState({});

  // keep local state in sync if parent item changes


  // ---------- Validation (manual) ----------
  const validate = (v) => {
    const e = {};
    const num = parseLocaleNumber(v.amount);

    if (num === null) {
      e.amount = getTranslation("Amount is required", "Amount is required", "Amount is required");
    } else {
      if (num <= 0) {
        e.amount = getTranslation("cant be negative", "cant be negative", "cant be negative");
      }
      // optional lower bound by current item's min (input has min attr too)
      if (typeof item?.amount === "number" && num < item.amount) {
        e.amount =
          getTranslation(
            "Amount cannot be less than the initial amount",
            "Amount cannot be less than the initial amount",
            "Amount cannot be less than the initial amount"
          ) || e.amount;
      }
    }
    return e;
  };


  // ---------- Render helpers ----------
  const DividerCell = useMemo(
    () => (
      <TableCell style={{ borderBottom: "none", padding: 0, width: 12 }}>
        <Divider
          orientation="vertical"
          variant="middle"
          style={{ height: 20, backgroundColor: "rgb(251,105,70)", margin: 0 }}
        />
      </TableCell>
    ),
    []
  );

  return (
    <TableRow>
      {/* Indexation */}
      <TableCell style={{ borderBottom: "none", paddingTop: 12, paddingRight: 8, width: 120 }}>
        <FormControl>
          <FormControlLabel
            style={{ width: 92 }}
            labelPlacement="start"
            disabled={disabled ? true : count < 2}
            control={
              <Checkbox
                id="isIndexed"
                checked={!!item.isIndexed}
                // onChange={(_, check) => setValues((s) => ({ ...s, isIndexed: check }))}
                onChange={(_, check) => onSubmit(count, { ...item, isIndexed: check })}

                // onBlur={commit}
                style={{ color: count < 1 ? "grey" : "rgb(251, 94, 57)" }}
              />
            }
          />
        </FormControl>
      </TableCell>

      {DividerCell}

      {/* Amount */}
      <TableCell style={{ borderBottom: "none", paddingTop: 12, paddingLeft: 8, paddingRight: 8, width: 180 }}>
        <LocaleNumberField
          variant="outlined"
          required
          fullWidth
          label={getTranslation("Amount", "Amount", "Amount")}
          name="eating"
          size="small"
          value={item?.amount}
          disabled={disabled}
          onChange={(e) => {
            onSubmit(count, { ...item, amount: e.target.value })
          }}
          error={Boolean(errors.amount)}
          helperText={errors.amount}
        />
        {/* <TextField
          fullWidth
          disabled={disabled}
          value={format("number", values.amount)}
          label={getTranslation("Amount", "Amount", "Amount")}
          variant="outlined"
          size="small"
          InputLabelProps={{ shrink: true }}
          style={{ boxShadow: "0px 2px 3px rgba(0,0,0,0.2)", borderRadius: 5 }}
          onChange={(e) => setValues((s) => ({ ...s, amount: e.target.value }))}
          onBlur={commit}
          error={Boolean(errors.amount)}
          helperText={errors.amount}
          InputProps={{ inputProps: { min: item?.amount } }}
        /> */}
      </TableCell>

      {DividerCell}

      {/* Type */}
      <TableCell style={{ borderBottom: "none", paddingTop: 12, paddingLeft: 8, paddingRight: 8, width: 180 }}>
        <FormControl fullWidth variant="outlined" 
        disabled={disabled ? true : count < 2}>
          <Select
            style={{ height: 40, width: 150 }}
            labelId={`dues-type-label-${count}`}
            id={`dues-type-${count}`}
            placeholder="Category"
            name="duesCategory"
            value={item.type}
            // onChange={(e) => setValues((s) => ({ ...s, type: e.target.value }))}
            onChange={(e) => onSubmit(count, { ...item, type: e.target.value })}
          // onBlur={commit}
          >
            {tenantCategories.map((category) => (
              <MenuItem key={category.id} value={category.id}>
                {category.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </TableCell>

      {DividerCell}

      {/* Description */}
      <TableCell style={{ borderBottom: "none", paddingTop: 12, paddingLeft: 8 }}>
        <TextField
          disabled={disabled}
          fullWidth
          value={item.description || ""}
          label={getTranslation("Description", "Description", "Description")}
          variant="outlined"
          size="small"
          InputLabelProps={{ shrink: true }}
          style={{ boxShadow: "0px 2px 3px rgba(0,0,0,0.2)", borderRadius: 5 }}
          // onChange={(e) => setValues((s) => ({ ...s, description: e.target.value }))}
          onChange={(e) => onSubmit(count, { ...item, description: e.target.value })}

          error={Boolean(errors.description)}
          helperText={errors.description}
        />
      </TableCell>

      {/* Delete */}
      <TableCell style={{ borderBottom: "none", paddingTop: 12, width: 52 }}>
        {count < 2 || disabled ? (
          ""
        ) : (
          <DeleteIConButton
            onClick={() => {
              // optional: pass a hint to parent before deletion
              onSubmit(count, { ...item, __delete: true });
              deleteItem(count, item);
            }}
          />
        )}
      </TableCell>
    </TableRow>
  );
};

export default SplitAmount;
